import { compose, createStore, applyMiddleware, Store } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducers from './legacyfrontend/redux/reducers/index-reduces';
import initialState from './legacyfrontend/redux/reducers/initial-state';
import { isServer, getWindow } from './legacyfrontend/helpers/ssr-helper';
import { saveApplicationState } from './legacyfrontend/helpers/applicationStateStorage';

type RootState = ReturnType<typeof reducers>;
type AppStore = Store<RootState>;
type PreloadedState = RootState | undefined;

const win = getWindow();
const preloadedState: PreloadedState = isServer ? initialState : win?.__PRELOADED_STATE__;
const composeEnhancers = isServer
  ? compose()
  : win?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose();

const store: AppStore = createStore(
  reducers,
  preloadedState,
  composeEnhancers(applyMiddleware(thunkMiddleware)),
);

if (!isServer) {
  let prevAppState = store.getState().applicationState;
  saveApplicationState(prevAppState);
  store.subscribe(() => {
    const next = store.getState().applicationState;
    if (next !== prevAppState) {
      prevAppState = next;
      saveApplicationState(next);
    }
  });
}

export default store;
